
let all_product = [
  {
    id: 1,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://m.advanceshipping.ru/img/vagon/kritii-vagon.png",
    new_price: 50.0,
    old_price: 80.5,
  },
  {
    id: 2,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://m.advanceshipping.ru/img/vagon/kritii-vagon.png",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 3,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://m.advanceshipping.ru/img/vagon/kritii-vagon.png",
    new_price: 60.0,
    old_price: 100.5,
  },
  {
    id: 4,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://m.advanceshipping.ru/img/vagon/kritii-vagon.png",
    new_price: 100.0,
    old_price: 150.0,
  },
  {
    id: 5,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/71GABCSqWK75kYqWax0hqn/49ac4c4c3eb1e41e239893c05e91a159/Corner.png?fm=png&fl=png8&q=50&w=500&h=300  ",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 6,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/2UBVeBykBElovg03TFisCt/75f3c583772110b91218323b4aaadd3a/22GB_20ft_standard_3doorhandles_new_White_Corner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 7,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/2hF4MdSimB8T4PogDM9s0I/af18477171e0f5ff8464aaa2b16d9b34/22GB_20ft_standard_3doorhandles_new_BlueCorner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 8,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/6Gxi0uTHppq7ugfoHJaJDo/40437c7b46ea356188b28b7eff3d060e/42G1_40FT_Standaard_Yellow_used_Corner_shadow.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 9,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/2hF4MdSimB8T4PogDM9s0I/af18477171e0f5ff8464aaa2b16d9b34/22GB_20ft_standard_3doorhandles_new_BlueCorner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 10,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/6Gxi0uTHppq7ugfoHJaJDo/40437c7b46ea356188b28b7eff3d060e/42G1_40FT_Standaard_Yellow_used_Corner_shadow.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 11,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/71GABCSqWK75kYqWax0hqn/49ac4c4c3eb1e41e239893c05e91a159/Corner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 12,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "storage-conatiners",
    image:"https://images.ctfassets.net/gc5htdx4kcus/21nNaGEfgWUqpuIOdkRrZ5/2502b305491cbd92f9ef614123dfbd13/22G1_20FT_STANDARD_NIEUW_ZWART_corner_new_copy.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 13,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/7yOuCg6OlFkCmKtUyxTlgp/843a84b66e24ebc5e2381b1fed5859aa/25G1_20FT_High_Cube_new_blue_corner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 14,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/6Gxi0uTHppq7ugfoHJaJDo/40437c7b46ea356188b28b7eff3d060e/42G1_40FT_Standaard_Yellow_used_Corner_shadow.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 15,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/343z7I67jgpF3eskZLNYrm/51865b13d4f66d346e3b52acf795b8b4/45G1_40FT_HIGH_CUBE_NEW_CORNER_BLUE_copy.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 16,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/eTclHtvxiuc7wFLvvKN43/398517bd29ba46fec33216a161ed4ea0/22K2_20ft_combi_Rent_Corner_Deur_Open.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 17,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/6A5cgQZtqydaawlfILIZT2/e33a4c9e26ab01a412e51d90b8ca6cec/25G1_20FT_HIGH_CUBE_BLAUW.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 18,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "storage-conatiners",
    image: "https://images.ctfassets.net/gc5htdx4kcus/3kpL1YnbyTtZT1bh2uAmqx/b208f19a4fee6a16ab85bbe84a20b645/42U9_40FT_OPEN_TOP_REBUILD_USED_CORNER.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 19,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/21nNaGEfgWUqpuIOdkRrZ5/2502b305491cbd92f9ef614123dfbd13/22G1_20FT_STANDARD_NIEUW_ZWART_corner_new_copy.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 20,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/7yOuCg6OlFkCmKtUyxTlgp/843a84b66e24ebc5e2381b1fed5859aa/25G1_20FT_High_Cube_new_blue_corner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 21,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/6Gxi0uTHppq7ugfoHJaJDo/40437c7b46ea356188b28b7eff3d060e/42G1_40FT_Standaard_Yellow_used_Corner_shadow.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 22,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/2hF4MdSimB8T4PogDM9s0I/af18477171e0f5ff8464aaa2b16d9b34/22GB_20ft_standard_3doorhandles_new_BlueCorner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 23,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/6A5cgQZtqydaawlfILIZT2/e33a4c9e26ab01a412e51d90b8ca6cec/25G1_20FT_HIGH_CUBE_BLAUW.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 24,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/3kpL1YnbyTtZT1bh2uAmqx/b208f19a4fee6a16ab85bbe84a20b645/42U9_40FT_OPEN_TOP_REBUILD_USED_CORNER.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 25,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/21nNaGEfgWUqpuIOdkRrZ5/2502b305491cbd92f9ef614123dfbd13/22G1_20FT_STANDARD_NIEUW_ZWART_corner_new_copy.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 26,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/7yOuCg6OlFkCmKtUyxTlgp/843a84b66e24ebc5e2381b1fed5859aa/25G1_20FT_High_Cube_new_blue_corner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 27,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/21nNaGEfgWUqpuIOdkRrZ5/2502b305491cbd92f9ef614123dfbd13/22G1_20FT_STANDARD_NIEUW_ZWART_corner_new_copy.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 28,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/1CXThEGrMHO7mdTF88iHTm/f495cfcc3d3efa0ca3e17462159a3d84/22L1_20FT_Furniture_white_new_Corner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 29,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/3kpL1YnbyTtZT1bh2uAmqx/b208f19a4fee6a16ab85bbe84a20b645/42U9_40FT_OPEN_TOP_REBUILD_USED_CORNER.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 30,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/6A5cgQZtqydaawlfILIZT2/e33a4c9e26ab01a412e51d90b8ca6cec/25G1_20FT_HIGH_CUBE_BLAUW.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 31,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/1CXThEGrMHO7mdTF88iHTm/f495cfcc3d3efa0ca3e17462159a3d84/22L1_20FT_Furniture_white_new_Corner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 32,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/6A5cgQZtqydaawlfILIZT2/e33a4c9e26ab01a412e51d90b8ca6cec/25G1_20FT_HIGH_CUBE_BLAUW.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 33,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/21nNaGEfgWUqpuIOdkRrZ5/2502b305491cbd92f9ef614123dfbd13/22G1_20FT_STANDARD_NIEUW_ZWART_corner_new_copy.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 34,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/3kpL1YnbyTtZT1bh2uAmqx/b208f19a4fee6a16ab85bbe84a20b645/42U9_40FT_OPEN_TOP_REBUILD_USED_CORNER.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 35,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/1CXThEGrMHO7mdTF88iHTm/f495cfcc3d3efa0ca3e17462159a3d84/22L1_20FT_Furniture_white_new_Corner.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 36,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "shipping-containers",
    image: "https://images.ctfassets.net/gc5htdx4kcus/3kpL1YnbyTtZT1bh2uAmqx/b208f19a4fee6a16ab85bbe84a20b645/42U9_40FT_OPEN_TOP_REBUILD_USED_CORNER.png?fm=png&fl=png8&q=50&w=500&h=300",
    new_price: 85.0,
    old_price: 120.5,
  },
];

export default all_product;
